import {listByAttributeName} from 'utils/list'
import {UPDATE_AUTH, UPDATE_USER, LOGOUT} from '../types'

const iState = {
  token: '',
  user: null,
  permissions: [],
  permissions_enum: {},
}

const Auth = (state = iState, action) => {
  switch (action.type) {
    case UPDATE_AUTH: {
      const user = action.payload
      const permissions = user.permissions ?? []
      const permissions_enum = listByAttributeName(permissions, 'module_id')
      return {...state, token: user.ACCESS_TOKEN, user, permissions, permissions_enum}
    }

    case UPDATE_USER: {
      const user = action.payload
      const permissions = user.permissions ?? []
      const permissions_enum = listByAttributeName(permissions, 'module_id')
      return {...state, user, permissions, permissions_enum}
    }

    case LOGOUT: {
      return {...state, token: '', user: null, permissions: [], permissions_enum: {}}
    }

    default: {
      return state
    }
  }
}

export default Auth
